import * as React from 'react';
import EmbeddedPowerBIReport from '../../../../components/Reporting';
import Grid from '@mui/material/Unstable_Grid2';
import { AppBar, Typography } from '@mui/material';
import Spacing from '../../../Layout/components/Spacing';

interface MonthlySummaryProps {
    productLineCode?: string;
}

const MonthlySummary: React.FunctionComponent<MonthlySummaryProps> = (props) => {
    const { productLineCode } = props;
    const PRODUCTION_BOUND_POLICIES_ID_CP = 'accd60ed-a74f-49a6-bc92-2a6e21fc525c';
    const PRODUCTION_BOUND_POLICIES_ID_GL = '012fb744-10b8-4726-822b-8adf50555128';
    const PRODUCTION_BOUND_POLICIES_WORKSPACE_ID = '5969b83e-5d39-4154-ad43-a016b71cd9e0';
    const PRODUCTION_BOUND_POLICIES_PAGENAME = '9b1a6ec54d01a6b180ab';

    return (
        <>
            <Grid>
                <AppBar position="static" color="default">
                    <Grid container justifyContent={'center'} alignItems={'center'}>
                        <Grid>
                            <Typography variant="h4" style={{ margin: 4 }}>
                                Monthly Summary
                            </Typography>
                        </Grid>
                    </Grid>
                </AppBar>
                <Spacing height={'24px'} />
            </Grid>
            <EmbeddedPowerBIReport
                reportId={
                    productLineCode === 'COMMERCIAL_PROPERTY'
                        ? PRODUCTION_BOUND_POLICIES_ID_CP
                        : PRODUCTION_BOUND_POLICIES_ID_GL
                }
                workspaceId={PRODUCTION_BOUND_POLICIES_WORKSPACE_ID}
                height={'100%'}
                hidePageNav
                hideFilters
                pageName={PRODUCTION_BOUND_POLICIES_PAGENAME}
                hideReportBorder
            />
        </>
    );
};

export default MonthlySummary;
